import { useEffect, useState } from 'react';

const LAG_MIN = -365;
const LAG_MAX = 365;

export function normalizeLagDays(raw: string): number {
  const trimmed = raw.trim();
  if (trimmed === '' || trimmed === '-') return 0;
  const parsed = Number.parseInt(trimmed, 10);
  if (Number.isNaN(parsed)) return 0;
  return Math.max(LAG_MIN, Math.min(LAG_MAX, parsed));
}

interface Props {
  value: number;
  onChange: (lag: number) => void;
  disabled?: boolean;
  className?: string;
  title?: string;
  'aria-label'?: string;
}

/** Text-based lag input — keeps “-” visible while typing negative values. */
export default function ScheduleTemplateLagInput({
  value,
  onChange,
  disabled,
  className = '',
  title,
  'aria-label': ariaLabel,
}: Props) {
  const [draft, setDraft] = useState(String(value));

  useEffect(() => {
    setDraft(String(value));
  }, [value]);

  return (
    <input
      type="text"
      inputMode="numeric"
      value={draft}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel}
      onChange={(e) => {
        const next = e.target.value;
        if (/^-?\d*$/.test(next)) {
          setDraft(next);
        }
      }}
      onBlur={() => {
        const normalized = normalizeLagDays(draft);
        setDraft(String(normalized));
        if (normalized !== value) {
          onChange(normalized);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          (e.target as HTMLInputElement).blur();
        }
      }}
      className={
        className ||
        'min-w-[4.5rem] w-20 px-2.5 py-1.5 rounded-lg border border-gray-200 text-sm text-right tabular-nums font-medium text-[#1A1A1A] focus:outline-none focus:border-[#E8621A]'
      }
    />
  );
}
